// extracted by mini-css-extract-plugin
export default {"headerDescription":"header-description_headerDescription__6rrR+"};